import React from "react";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import "../../styles/forms.scss";

const Motivations = () => {
  const {
    interview,
    setInterview
  } = useInterviewContext();
  const { t } = useTranslation();

  const onChangeAvailabilityAndConditions = ({ target }) => {
    const availabilityAndConditions = {
      ...interview.availabilityAndConditions
    };
    availabilityAndConditions[target.name] = target.value;
    setInterview((interview) => ({
      ...interview,
      availabilityAndConditions: availabilityAndConditions
    }));
  }

  return (
    <form className="salary-condition">
      <h1>{t("Motivations")}</h1>
      <div className="form-group">
        <label htmlFor="exitReason">{t("Exit Reason")}</label>
        <textarea
          rows="4"
          className="form-control"
          id="exitReason"
          name="exitReason"
          value={interview.availabilityAndConditions.exitReason}
          onChange={onChangeAvailabilityAndConditions}
          placeholder={t("Reasons...")}
        />
        <label htmlFor="otherProposals">{t("Other Proposals")}</label>
        <textarea
          rows="4"
          className="form-control"
          id="otherProposals"
          name="otherProposals"
          value={interview.availabilityAndConditions.otherProposals}
          onChange={onChangeAvailabilityAndConditions}
          placeholder={t("Proposals...")}
        />
      </div>
    </form>
  );
};

export default Motivations;
